import {
  NextBestActionDefinitionAction,
  NextBestActionType,
} from "../../../../../../projection/nextBestActionDefinition/nextBestActionDefinition";

const findCardActionBySlug = (
  actions: NextBestActionDefinitionAction[],
  slug: string,
): NextBestActionDefinitionAction<NextBestActionType.CARD> | undefined => {
  for (const action of actions) {
    if (action.type === NextBestActionType.CARD) {
      const cardAction = action as NextBestActionDefinitionAction<NextBestActionType.CARD>;
      if (cardAction.metadata?.slug === slug) {
        return cardAction;
      }
    } else if ("children" in action && action.children) {
      const found = findCardActionBySlug(action.children, slug);
      if (found) {
        return found;
      }
    }
  }

  return undefined;
};

export { findCardActionBySlug };
